export default {
aboutservice: {
  title1: "Order Smarter",

  from: "with",
  highlight: "MAHAL Marketplace",

  desc:
    "Buy smarter and operate better. Communicate with suppliers, place and track orders, explore an all-in-one marketplace, and generate LPOs with ease, all inside the MAHAL platform.",

  text:
    "Order smarter, spend less. Chat with suppliers, place and track every order, explore a complete marketplace, and generate LPOs, all in one unified MAHAL platform. Efficiency that truly feels effortless.",

  li1: "Live Supplier Chat",
  li2: "Smart LPO Generation",
  li3: "Marketplace Access",
  li4: "Order Tracking",

  cta: "Restaurant Portal",
}
};